export default "__VITE_ASSET__C9HyB9hU__"